import type { MetaFunction } from 'react-router'
import EventsPage from '~/pages/EventsPage.jsx'

export const meta: MetaFunction = () => [
  { title: 'Events | S.J.S. Technology' },
  {
    name: 'description',
    content:
      'Workshops, exhibitions, and partner meets hosted by S.J.S. Technology — stay updated on upcoming events and see highlights from past programs.',
  },
  { property: 'og:title', content: 'Events | S.J.S. Technology' },
  { property: 'og:url', content: 'https://sjstechnology.in/events' },
]

export default function Events() {
  return <EventsPage />
}
